import * as React from 'react';
import { Modal, Button } from 'react-bootstrap';

type Props = {
  show: boolean;
  onHide: () => void;
  // Embed URL — build it with youtube(...) / loom(...) from models/sectionVideos.
  src: string;
  title: string;
};

// Plays one section's explainer video. Rendering is all-or-nothing on `show`:
// returning null keeps the <iframe> out of the DOM entirely, so none of the
// section headers carrying this component preload a video they may never play.
export const SectionVideoModal = ({ show, onHide, src, title }: Props) => {
  if (!show) {
    return null;
  }

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton style={{ backgroundColor: '#337ab7', color: '#fff' }}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Responsive 16:9 embed */}
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            title={title}
            src={src}
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};
